import { environment } from "../../environments/environment";
import * as AfEnv from 'src/environments/environment';

const WidgetControllers = {
  Vehicle: `${environment.WIDGET_API_URI}Vehicle`,
  Workshop: `${environment.WIDGET_API_URI}Workshop`,
  Appointment: `${environment.WIDGET_API_URI}Appointment`,
  Setting: `${environment.WIDGET_API_URI}Setting`,
  Brand: `${environment.WIDGET_API_URI}Brands`,
  Service: `${environment.WIDGET_API_URI}Services`,
  Postcode: `${environment.WIDGET_API_URI}Postcode`
}

const LocalizationControllers = {
  Localization: `${AfEnv.environment.LOCALIZATION_API_URL}Localization`
}

export const enum KeyValue {
  DefaultLanguage = 'en-US',
  ModuleForLocalization = 'Widget'
}
export const Urls = {
  //Localization
  GetLocalization: `${LocalizationControllers.Localization}/Application`,
  
  // Brand
  GetBrands: `${WidgetControllers.Brand}/GetAll`,

  // Setting
  GetCurrency: `${WidgetControllers.Setting}/Get`,
  GetGenericSettings: `${WidgetControllers.Setting}/GetGenericSettings`,
  GetSettings: `${WidgetControllers.Setting}/GetSettings`,
  GetFeatures: `${WidgetControllers.Setting}/GetFeatures`,
  GetFeaturesByDealer: `${WidgetControllers.Setting}/GetFeaturesByDealer`,
  GetGenericFeatures: `${WidgetControllers.Setting}/GetGenericFeatures`,

  // Service
  GetSelectServiceSectionDetails: `${WidgetControllers.Service}/GetAll`,
  GetWarningLightDropdown:`${WidgetControllers.Service}/GetWarningLightDropdown`,
  GetCustomerWaitingTime: `${WidgetControllers.Service}/CheckWaitingTime`,

  // Workshop
  GetServicesByDealerId: `${WidgetControllers.Workshop}/GetDealerServicesByDealerId`,
  GetAllDealerDetails: `${WidgetControllers.Workshop}/GetAllDealerDetails`,
  GetDealerCapacityDetails: `${WidgetControllers.Workshop}/Get`,
  GetMechanicSlotsDetails: `${WidgetControllers.Workshop}/GetSlots`,
  GetSplitMechanicSlotsDetails: `${WidgetControllers.Workshop}/GetSplitBooking`,
  ReserveMechanicSlot: `${WidgetControllers.Workshop}/AddReserveSlots`,
  GetDealerRentalCars: `${WidgetControllers.Workshop}/GetDealerRentalCars`,
  GetGenericRentalCars: `${WidgetControllers.Workshop}/GetGenericRentalCars`,
  GetAdditionalServices: `${WidgetControllers.Workshop}/GetDealerAdditionalServices`,
  CheckReserveSlotAvailability: `${WidgetControllers.Workshop}/CheckReserveSlotAvailability`,
  CallDealerLogEntry:`${WidgetControllers.Workshop}/CallDealerLogEntry`,
  
  // Vehicle
  getVehicleDetailsByVehicleno:`${WidgetControllers.Vehicle}/vehicleinformation`,
  getVehicleDetailsFromDMSByVehicleno:`${WidgetControllers.Vehicle}/GetVehicleInformationFromDMS`,
  AddVehicleCustomerDetails:`${WidgetControllers.Vehicle}/AddVehicleCustomerDetails`,
  AddMobileOTPDetails: `${WidgetControllers.Vehicle}/AddMobileOTPDetails`,
  GetNewCustomerDetails: `${WidgetControllers.Vehicle}/GetNewCustomerDetails`,
  GetVehicleTransmissionDropdownList:`${WidgetControllers.Vehicle}/GetVehicleTransmissionDropdownList`,
  GetModelnoDropdownList:`${WidgetControllers.Vehicle}/GetModelnoDropdownList`,
  GetVehicleByLicensePlateNoOrVIN:`${WidgetControllers.Vehicle}/GetVehicleByLicensePlateNoOrVIN`,
  CreateContact: `${WidgetControllers.Vehicle}/CreateContact`,
  AssignDriverToVehicle: `${WidgetControllers.Vehicle}/AssignDriverToVehicle`,
  GetCustomerAndVehicleDetails: `${WidgetControllers.Vehicle}/GetVehicleDetailsForWidget`,
  GetCustomerVehiclesByMobileNo: `${WidgetControllers.Vehicle}/GetCustomerVehiclesByMobileNo`,
  GetBrandList: `${WidgetControllers.Vehicle}/GetBrandList`,
  GetVehicleTypes: `${WidgetControllers.Vehicle}/GetVehicleTypes`,
  GetCountryCodeAndMobileCodeDetails: `${WidgetControllers.Vehicle}/GetCountryNameAndMobileCodeList`,
  GetFuelTypeDetails: `${WidgetControllers.Vehicle}/GetAllFuelType`,
  CheckCustomerAvailable: `${WidgetControllers.Vehicle}/CheckCustomerAvailable`,
  AddCustomerVehicleDetails: `${WidgetControllers.Vehicle}/AddCustomerVehicleDetails`,
  AddCustomerMobile: `${WidgetControllers.Vehicle}/SaveCustomerNumber`,
  GetNewVehicleByLicensePlateNo: `${WidgetControllers.Vehicle}/GetNewVehicleByLicensePlateNo`,

  // Appointment
  CreateAppointment: `${WidgetControllers.Appointment}/Create`,
  VerifyOTP: `${WidgetControllers.Appointment}/ValidateOtp`,
  ValidateMobileOtp: `${WidgetControllers.Appointment}/ValidateMobileOtp`,

  //PostCode
  GetPostCodeDropdown: `${WidgetControllers.Postcode}/postcodeDropdown`
}
